import { saveAs } from "file-saver";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import { getAllData } from "../../../Utils/firebaseServices";
import LoadingCircular from "../../../loader/LoadingCircular";
import CustomTableII from "../CustomTable";

const OnlineContact = () => {
  const [financeContact, setFinanceContact] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        await getAllData("contactMessages", (allData) => {
          const onlineData = allData.filter(
            (item) => item.source !== "offline-form"
          );
          setFinanceContact(onlineData);
        });
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleDownloadExcel = () => {
    if (!financeContact.length) {
      alert("No data to export.");
      return;
    }
    const filtereddata = financeContact.map((item, index) => ({
      "sr.no": index + 1,
      Name: item.name || "NA",
      Email: item.email || "NA",
      Phone: item.phone || "NA",
      Message: item.message || "NA",
      Action: item.assignedTo?.selectedEmpName || "NA",
      Source: item.source === "offline-form" ? "" : "Online form",
    }));

    const worksheet = XLSX.utils.json_to_sheet(filtereddata);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "OnlineContacts");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "OnlineContacts.xlsx");
  };

  if (loading) {
    return <LoadingCircular />;
  }

  return (
    <>
      <div
        className="hide"
        style={{ fontSize: "30px", fontWeight: "700", marginBottom: "10px" }}
      >
        OnlineContact
      </div>

      <div style={{ display: "flex", gap: "10px", marginBottom: "20px", marginLeft:"20px" }}>
        <button className="btn btn-success" onClick={handleDownloadExcel}>
          ⬇️ Download Excel
        </button>
      </div>
      <CustomTableII
        data={financeContact}
        coll={["Name", "Email", "Phone", "Message"]}
      />
    </>
  );
};

export default OnlineContact;
